import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../environments/environment";
import {
  ReportingEntity,
  ReportingEntitiesResponse,
  ReportingEntityFilters,
  ReportingEntityMutationResponse,
  ReportingEntityCompaniesResponse,
  ReportingEntitySuccessResponse
} from '../_models/reporting-entity.model';

@Injectable({
  providedIn: 'root'
})
export class ReportingEntityService {

  constructor(private http: HttpClient) { }

  getReportingEntities(page: number = 1, limit: number = 10, filters?: ReportingEntityFilters): Observable<ReportingEntitiesResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    
    if (filters) {
      if (filters.name) params = params.set('name', filters.name);
      if (filters.includePrimaryContact) params = params.set('includePrimaryContact', 'true');
      if (filters.includeDivisions) params = params.set('includeDivisions', 'true');
      if (filters.includeServiceDivisions) params = params.set('includeServiceDivisions', 'true');
      if (filters.isHoldingCompany) params = params.set('isHoldingCompany', 'true');
    }
    
    return this.http.get<ReportingEntitiesResponse>(`${environment.apiUrl}/reporting-entities`, { params });
  }

  getReportingEntity(id: number, includeCompanies: boolean = false, includePrimaryContact: boolean = false, includeDivisions: boolean = false): Observable<ReportingEntity> {
    let params = new HttpParams();
    
    if (includeCompanies) {
      params = params.set('includeCompanies', 'true');
    }
    
    if (includePrimaryContact) {
      params = params.set('includePrimaryContact', 'true');
    }
    
    if (includeDivisions) {
      params = params.set('includeDivisions', 'true');
    }
    
    return this.http.get<ReportingEntity>(`${environment.apiUrl}/reporting-entities/${id}`, { params });
  }

  createReportingEntity(entity: ReportingEntity): Observable<ReportingEntityMutationResponse> {
    return this.http.post<ReportingEntityMutationResponse>(`${environment.apiUrl}/reporting-entities`, entity);
  }

  updateReportingEntity(id: number, entity: ReportingEntity): Observable<ReportingEntityMutationResponse> {
    return this.http.put<ReportingEntityMutationResponse>(`${environment.apiUrl}/reporting-entities/${id}`, entity);
  }

  deleteReportingEntity(id: number): Observable<ReportingEntitySuccessResponse> {
    return this.http.delete<ReportingEntitySuccessResponse>(`${environment.apiUrl}/reporting-entities/${id}`);
  }

  getCompaniesForReportingEntity(id: number, page: number = 1, limit: number = 10): Observable<ReportingEntityCompaniesResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    return this.http.get<ReportingEntityCompaniesResponse>(`${environment.apiUrl}/reporting-entities/${id}/companies`, { params });
  }

  // These methods will need corresponding backend endpoints
  addCompanyToReportingEntity(reportingEntityId: number, companyId: number): Observable<ReportingEntitySuccessResponse> {
    return this.http.post<ReportingEntitySuccessResponse>(`${environment.apiUrl}/reporting-entities/${reportingEntityId}/companies`, { companyId });
  }

  removeCompanyFromReportingEntity(reportingEntityId: number, companyId: number): Observable<ReportingEntitySuccessResponse> {
    return this.http.delete<ReportingEntitySuccessResponse>(`${environment.apiUrl}/reporting-entities/${reportingEntityId}/companies/${companyId}`);
  }
}
